module.exports = __webpack_public_path__ + "img/bike_inactive.c0f06ee5.svg";